<template>
  <div class="box">
    <div class="main">
      <van-cell-group v-for="(infor,index) in list" :key="index">
        <van-cell :title="infor.title" :value="infor.main" />
      </van-cell-group>
    </div>
    <div class="footer">
      <van-button type="info" :round="true" size="small" style="margin-right:10px">取消</van-button>
      <van-button type="info" :round="true" size="small" style="margin-left:10px" @click="go" >确认</van-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'confirmData',
  data() {
    return {
      list: [
        {
          title: '体检人：',
          main: '李成成'
        },
        {
          title: '科室：',
          main: '体检中心'
        },
        {
          title: '地址：',
          main: '体检中心'
        },
        {
          title: '套餐：',
          main: '套餐1'
        },
        {
          title: '预约时间：',
          main: '2020-02-20'
        }
      ]
    }
  },
  created() {},
  mounted() {},
  methods: {
    onClickLeft() {},
    go(){
      this.$router.push("goPrevention")
    }
  }
}
</script>
<style scoped>
.van-cell /deep/ .van-cell__title {
  -webkit-box-flex: 0.25;
  -webkit-flex: 0.25;
  flex: 0.25;
  color: #969799;
}
.van-cell /deep/ .van-cell__value {
  -webkit-box-flex: 0.5;
  -webkit-flex: 0.5;
  flex: 0.5;
  color: #323233;
  text-align: left;
}
.footer {
  width: 100vw;
  position: fixed;
  bottom: 0px;
  left: 0px;
  right: 0px;
  display: flex;
  background-color: #ffffff;
}
.footer button {
  width: calc(100% - 40px);
  margin: 10px 20px 10px 20px;
}
</style>
